import { Injectable } from "@angular/core";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { DatePipe } from "@angular/common";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { ResultadoPaginado } from "src/app/model/resultado";
import { MascaraCnaeImpedido } from "src/app/model/mascara-cnae-impedido.model";
import { LabelTipoOperacao } from "src/app/model/modalidade_garantia.model";
import { ObjetivosFinanciamentoMap } from "src/app/model/objetivo-financiamento.model";

const LIMITE_EXPORTACAO_CSV = 5000;

@Injectable({
    providedIn: 'root'
})
export class ExportService {
    private totalResultados: number = 0;
    public labelsOperacao = LabelTipoOperacao;
    public labelsObjetivoFinanciamento = ObjetivosFinanciamentoMap;

    constructor(
        private fileUtils: FileUtilsService,
        private datePipe: DatePipe,
        private loading: BnLoadingService,
        private bnAlertsService: BnAlertsService
    ) {}

    exportar(nome, csv) {
        if (this.totalResultados > LIMITE_EXPORTACAO_CSV) {
            this.bnAlertsService.alertaAviso('Atenção', 'A exportação está limitada às primeiras 5.000 operações. Utilize os filtros disponíveis para adequar a consulta.');
        }
        this.loading.liberaTela();
        this.fileUtils.exportarArquivo(nome, "\ufeff" + csv, FileUtilsService.TEXT_CSV);
    }

    exportarCnaes(resp: ResultadoPaginado<MascaraCnaeImpedido>) {
        let cnaes = resp?.resultados || null;
        this.totalResultados = resp.totalRegistrosSemPaginacao;
        let csv = 'MASCARA; TIPO DA OPERACAO; OBJETIVO DO FINANCIAMENTO; INICIO DA VALIDADE DO IMPEDIMENTO; FIM DA VALIDADE DE IMPEDIMENTO; DATA ULTIMA ATUALIZACAO; LOGIN ULTIMA ATUALIZACAO\n';
        cnaes.forEach(cnae => {
            let tipo = '';
            let objetivo = '';
            if(cnae.codigoTipoOperacao != null) {
                tipo = this.labelOperacao(cnae.codigoTipoOperacao);
            }

            if(cnae.codigoObjetivoFinanciamento != null) {
                objetivo = this.labelObjetivoFinanciamento(cnae.codigoObjetivoFinanciamento);
            }

            csv += cnae.mascara?.toUpperCase() + ';'
            + tipo + ';'
            + objetivo + ';'
            + this.formatarData(cnae.dataInicioValidadeImpedimento) + ';'
            + this.formatarData(cnae.dataFimValidadeImpedimento) + ';'
            + this.formatarData(cnae.dataUltimaAtualizacao) + ';'
            + cnae.loginUltimaAtualizacao?.toUpperCase() + '\n';
        });
        this.exportar('CnaesImpedidosOperar.csv', csv);
    }

    public labelOperacao(item) {
        return this.labelsOperacao.get(item);
    }

    public labelObjetivoFinanciamento(item) {
        return this.labelsObjetivoFinanciamento.get(item);
    }

    formatarData(data: string | number | Date, comHora?: boolean) {
        const hora = comHora ? 'HH:mm:ss' : '';
        return data ? this.datePipe.transform(data, 'dd/MM/yyyy ' + hora) : '';
    }

    formatarVirgula(valor: string) {
        return valor?.replace(/\./g, ',');
    }

}
